import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const ContactPersonNameCellContent: React.FC<
	ContactPersonNameCellContent.Props
> = ({ item }) => {
	const content = useMemo(
		() => item.additionalFields?.contactPersonName ?? "",
		[item.additionalFields?.contactPersonName],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ContactPersonNameCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default ContactPersonNameCellContent;
